import React from 'react';
import Layout from './components/Layout';
import FAQ from './components/FAQ';
import SEO from './components/SEO';

const FAQPage: React.FC = () => {
  return (
    <Layout>
      <SEO 
        title="NOPRBLM | Frequently Asked Questions"
        description="Find answers to common questions about NOPRBLM's services, process, and how we work with clients. Learn more about our creative and tech solutions."
        keywords="NOPRBLM FAQ, NOPRBLM questions, creative agency FAQ, tech partners questions, brand strategy FAQ"
        canonicalUrl="/faq"
      />
      <section className="hero hero-simple">
        <h1>FAQ</h1>
      </section>
      
      <section className="section">
        <div className="container-sm">
          <p className="section-subtitle">
            Find answers to frequently asked questions about our services, process, and how we work with clients.
            If you don't see your question here, please feel free to <a href="/contact">contact us</a>.
          </p>
          <FAQ />
        </div>
      </section>
    </Layout>
  );
};

export default FAQPage;